export const getLmsPortalUrl = () => {
  if (process.env.REACT_APP_LMS_PORTAL_URL) {
    return process.env.REACT_APP_LMS_PORTAL_URL;
  }

  const isLocal = window.location.hostname === 'localhost';
  return isLocal ? `${window.location.origin}/lms` : 'https://portal.schoolofshem.com';
};

export const getRegisterUrl = () => {
  const origin = window.location.origin;
  return `${origin}/register`;
};

export const getBookMeetingUrl = () => {
  if (process.env.REACT_APP_BOOK_MEETING_URL) {
    return process.env.REACT_APP_BOOK_MEETING_URL;
  }

  const defaultMessage = encodeURIComponent('Hello School of Shem, I would like to book a meeting.');
  return `https://wa.me/27615871145?text=${defaultMessage}`;
};
